import { useEffect, useState } from "react";
import { getOperatorName, clearOperator } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { UserRound, X } from "lucide-react";
import OperatorPinDialog from "@/components/OperatorPinDialog";
import { toast } from "sonner";

/**
 * Quem está operando este aparelho agora.
 *
 * Diferente do QuickSwitcher (que troca a SESSÃO inteira com e-mail e senha):
 * aqui o login do aparelho não muda, só a identidade de quem responde pelas
 * gravações. É o que permite deixar um PDV de balcão logado o dia inteiro sem
 * que todas as vendas do salão saiam no nome da mesma pessoa.
 *
 * Sem ninguém identificado, o backend atribui ao usuário logado — o
 * comportamento de sempre. Por isso o botão convida, não obriga.
 */
export default function OperatorSwitcher() {
  const [nome, setNome] = useState(getOperatorName());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onChange = (e) => setNome(e?.detail?.name || null);
    window.addEventListener("operator-changed", onChange);
    return () => window.removeEventListener("operator-changed", onChange);
  }, []);

  const sair = () => {
    clearOperator();
    toast.success("Turno encerrado neste aparelho");
  };

  return (
    <>
      <div className="flex items-center gap-1 px-1">
        <Button
          variant="ghost"
          className="flex-1 justify-start text-neutral-600 dark:text-neutral-400 dark:hover:bg-white/[0.04]"
          onClick={() => setOpen(true)}
          data-testid="operator-switch-btn"
          title={nome ? "Trocar operador" : "Identificar-se com PIN"}
        >
          <UserRound className="w-4 h-4 mr-2" />
          <span className="truncate">{nome || "Identificar operador"}</span>
        </Button>
        {nome && (
          <Button variant="ghost" size="icon" onClick={sair}
                  title="Encerrar turno neste aparelho" data-testid="operator-clear-btn">
            <X className="w-4 h-4" />
          </Button>
        )}
      </div>
      <OperatorPinDialog
        open={open}
        onOpenChange={setOpen}
        onIdentified={(op) => toast.success(`Operando como ${op.name}`)}
      />
    </>
  );
}
